import { Link, useLocation } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import "./BreadCrumb.css";
 
const Breadcrumbs = ({ breadcrumbcls = "" }) => {
  const location = useLocation();
  const path = location.pathname;
  const user = JSON.parse(localStorage.getItem("user"));
 
  const { pathname } = location;
  const pathSegments = pathname.split("/");
  const buildDynamicUrl = (url) => {
    if (!url) return "";
    return url
      .split("/")
      .map((segment, id) => {
        if (segment.startsWith(":")) {
          return pathSegments[id];
        }
        return segment;
      })
      .join("/");
  };
 
  //  Define all your custom breadcrumb routes
  const breadcrumbConfig = {
    "/billingAndInvoice/invoicing": [
      { label: "Dashboard", url: "/" },
      { label: "Billing & Invoice", url: "/billingAndInvoice/invoicing" },
      { label: "Invoicing" },
    ],
    "/invoice-details": [
      { label: "Dashboard", url: "/" },
      { label: "Billing & Invoice", url: "/billingAndInvoice/invoicing" },
      { label: "Invoicing", url: "/billingAndInvoice/invoicing" },
      { label: "Tax Invoice" },
    ],
    "/purchase-details": [
      { label: "Dashboard", url: "/" },
      { label: "Billing & Invoice", url: "/billingAndInvoice/invoicing" },
      { label: "Invoicing", url: "/billingAndInvoice/invoicing" },
      { label: "Purchase Details" },
    ],
    "/my-enquiry/create-enquiry": [
      { label: "Dashboard", url: "/" },
      { label: "Create Enquiry" },
    ],
 
    "/my-enquiry/view-enquiry": [
      { label: "Dashboard", url: "/" },
      { label: "View Enquiry" },
    ],
 
    "/my-enquiry/view-enquiry-details": [
      { label: "Dashboard", url: "/" },
      ...(user?.user_role === "User"
        ? [{ label: "View Enquiry", url: "/my-enquiry/view-enquiry" }]
        : user?.user_role === "sales_rep"
          ? [{ label: "Freight Enquiries", url: "/freight-enquiries" }]
          : []),
      { label: "View Enquiry Details" },
    ],
 
    "/my-enquiry/edit-enquiry": [
      { label: "Dashboard", url: "/" },
      ...(user?.user_role === "User"
        ? [{ label: "View Enquiry", url: "/my-enquiry/view-enquiry" }]
        : user?.user_role === "sales_rep"
          ? [{ label: "Freight Enquiries", url: "/freight-enquiries" }]
          : []),
      { label: "Edit Enquiry" },
    ],
 
    "/view-quotation": [
      { label: "Dashboard", url: "/" },
      ...(user?.user_role === "User"
        ? [{ label: "View Enquiry", url: "/my-enquiry/view-enquiry" }]
        : user?.user_role === "Admin" || user?.user_role === "SuperAdmin"
          ? [{ label: "Pending Enquiries", url: "/freight/pending-enquiries" }]
          : user?.user_role === "sales_rep"
            ? [{ label: "Freight Enquiries", url: "/freight-enquiries" }]
            : []),
      { label: "View Quotation" },
    ],
 
    ...(user?.user_role === "User"
      ? [{ label: "View Enquiry", url: "/my-enquiry/view-enquiry" }]
      : user?.user_role === "Admin" || user?.user_role === "SuperAdmin"
        ? [{ label: "Pending Enquiries", url: "/freight/pending-enquiries" }]
        : []),
 
    "/my-bookings/view-bookings": [
      { label: "Dashboard", url: "/" },
      ...(user?.user_role === "User"
        ? [{ label: "List Of Bookings", url: "/my-bookings/list-of-bookings" }]
        : user?.user_role === "sales_rep"
          ? [{ label: "Freight Enquiries", url: "/freight-enquiries" }]
          : []),
      { label: "View Bookings" },
    ],
 
    "/my-bookings/create-shipping-instructions/": [
      { label: "Dashboard", url: "/" },
      ...(user?.user_role === "User"
        ? [{ label: "List Of Bookings", url: "/my-bookings/list-of-bookings" }]
        : user?.user_role === "sales_rep"
          ? [{ label: "Freight Enquiries", url: "/freight-enquiries" }]
          : []),
      { label: "Create Shipping Instructions" },
    ],
 
    "/upload-documents": [
      { label: "Dashboard", url: "/" },
      { label: "Upload Documents" },
    ],
 
    "/my-bookings/list-of-bl": [
      { label: "Dashboard", url: "/" },
      { label: "List of BL" },
    ],
 
    "/my-bookings/list-of-bookings": [
      { label: "Dashboard", url: "/" },
      { label: "List Of Bookings" },
    ],
 
    "my-bookings/view-bookings": [
      { label: "Dashboard", url: "/" },
      { label: "View Bookings" },
    ],
 
    "/user-profile": [
      { label: "Dashboard", url: "/" },
      { label: "User Profile" },
    ],
    "/master-data/exchange-rate": [
      { label: "Dashboard", url: "/" },
      { label: "Exchange Rate" },
    ],
    "/master-data/charge-code": [
      { label: "Dashboard", url: "/" },
      { label: "Charge Code" },
    ],
    "/master-data/vendor-master": [
      { label: "Dashboard", url: "/" },
      { label: "Vendor Master" },
    ],
    "/master-data/ports": [
      { label: "Dashboard", url: "/" },
      { label: "Port List" },
    ],
 
    "/master-data/job-master": [
      { label: "Dashboard", url: "/" },
      { label: "Job Master" },
    ],
    "/view-booking-documents": [
      { label: "Dashboard", url: "/" },
      {
        label: "Container Status Report",
        url: "/master-data/container-status-report",
      },
      { label: "View Booking Documents" },
    ],
 
    "/edit-container-status": [
      { label: "Dashboard", url: "/" },
      {label: "Job Master", url: "/master-data/job-master"},
      { label: "Edit Container Status" },
    ],
    "/operations": [
      { label: "Dashbboard", url: "/" },
      { label: "Edit Container Status", url: "/edit-container-status/:id" },
      { label: "Operations", url: "/edit-container-status" },
    ],
    "/commercial": [
      { label: "Dashbboard", url: "/" },
      { label: "Edit Container Status", url: "/edit-container-status/:id" },
      { label: "Commercial", url: "/commercial" },
    ],
 
    "/documents":[
     
      { label: "Dashbboard", url: "/" },
        { label: "Edit Container Status", url: "/edit-container-status/:id" },
        {label: "Documents" , url: "/documents"},
 
    ],
    "/master-data/client-master": [
      { label: "Dashbboard", url: "/" },
      { label: "Client Master" },
    ],
 
    "/master-data/user-master": [
      { label: "Dashboard", url: "/" },
      { label: "User Master" },
    ],
 
    "/master-data/terms-and-conditions": [
      { label: "Dashboard", url: "/" },
      { label: "Terms & Conditions" },
    ],
 
    "/freight/pending-enquiries": [
      { label: "Dashboard", url: "/" },
      { label: "Pending Enquiries" },
    ],
 
    // Admin  Routes Start
 
    "/admin/user": [
      { label: "Dashboard", url: "/" },
      { label: "Unverified Users", url: "/unverified-users" },
      { label: "User Documents" },
    ],
 
    "/send-quotation/": [
      { label: "Dashboard", url: "/" },
      { label: "Pending Enquiries", url: "/freight/pending-enquiries" },
      { label: "Send Quotation" },
    ],
 
    "/freight/view-booking/admin": [
      { label: "Dashboard", url: "/" },
      { label: "List of Booking" },
    ],
 
    "/my-bookings/edit-shipping-instructions": [
      { label: "Dashboard", url: "/" },
      { label: "List of BL", url: "/my-bookings/list-of-bl" },
      { label: "Edit Shipping" },
    ],
    "/my-bookings/edit-bookings/admin": [
      { label: "Dashboard", url: "/" },
      { label: "List of Booking", url: "/freight/view-booking/admin" },
      { label: "Edit Bookings", url: "/" },
    ],
    "/my-bookings/view-bookings/admin": [
      { label: "Dashboard", url: "/" },
      { label: "List of Bookings", url: "/freight/view-booking/admin" },
      { label: "View Booking" },
    ],
 
    "/list-of-bl/admin": [
      { label: "Dashboard", url: "/" },
      { label: "List of SI/BL" },
    ],
    "/view-si/admin": [
      { label: "Dashboard", url: "/" },
      ...(user?.user_role === "User"
        ? [{ label: "List Of Bookings", url: "/my-bookings/list-of-bookings" }]
        : user?.user_role === "Admin" || user?.user_role === "SuperAdmin"
          ? [{ label: "List of SI/BL", url: "/list-of-bl/admin" }]
          : []),
      { label: "View Si" },
    ],
    "/create-si/admin": [
      { label: "Dashboard", url: "/" },
      { label: "List of SI/BL", url: "/list-of-bl/admin" },
      { label: "Create Si" },
    ],
 
    "/sales-clients": [
      { label: "Dashboard", url: "/" },
      { label: "Sales Dashboard", url: "/sales-dashboard" },
      { label: "Client List" },
    ],
 
    "/sales-view-enquiry": [
      { label: "Dashboard", url: "/" },
      { label: "Sales Dashboard", url: "/sales-dashboard" },
      { label: "Client List", url: "/sales-clients" },
      { label: "View Enquiry" },
    ],
    "/sales-enquiries": [
      { label: "Dashboard", url: "/" },
      { label: "Sales Dashboard", url: "/sales-dashboard" },
      { label: "Client List", url: "/sales-clients" },
      { label: "Enquiry List" },
    ],
    "/sales-bookings": [
      { label: "Dashboard", url: "/" },
      { label: "Sales Dashboard", url: "/sales-dashboard" },
      { label: "Confirmed Bookings" },
    ],
    "/sales-dashboard": [
      { label: "Dashboard", url: "/" },
      { label: "Sales Dashboard" },
    ],
    "/total-followups": [
      { label: "Dashboard", url: "/" },
      { label: "Sales Dashboard", url: "/sales-dashboard" },
      { label: "Total Followups" },
    ],
    "/view-followup-details": [
      { label: "Dashboard", url: "/" },
      { label: "Sales Dashboard", url: "/sales-dashboard" },
      { label: "Total Followups", url: "/total-followups" },
      { label: "View Followup Details" },
    ],
    "/special-enquiries": [
      { label: "Dashboard", url: "/" },
      { label: "Sales Dashboard", url: "/sales-dashboard" },
      { label: "Special Enquiries" },
    ],
    "/high-volume-customers": [
      { label: "Dashboard", url: "/" },
      { label: "Sales Dashboard", url: "/sales-dashboard" },
      { label: "High Volume Customers" },
    ],
 
    //  Admin Routes End
    "/unverified-users": [
      { label: "Dashboard", url: "/" },
      { label: "Unverifed Users" },
    ],
    "/admin-user-documents": [
      { label: "Dashboard", url: "/" },
      { label: "Admin User Documents" },
    ],
    "/gst-update-requests": [
      { label: "Dashboard", url: "/" },
      { label: "GST Update Requests" },
    ],
 
    // Sales BreadCrumbs Routes
    "/freight-enquiries": [
      { label: "Dashboard", url: "/" },
      { label: "Freight Enquiries" },
    ],
    "/create-enquiry": [
      { label: "Dashboard", url: "/" },
      { label: "Freight  Enquiries", url: "/freight-enquiries" },
      { label: "Create-Enquiry" },
    ],
    "/my-enquiry/edit-enquiry/:id": [
      { label: "Dashboard", url: "/" },
      { label: "Freight  Enquiries", url: "/freight-enquiries" },
      { label: "Edit Enquiry" },
    ],
    "/my-enquiry/view-enquiry-details/:id": [
      { label: "Dashboard", url: "/" },
 
      { label: "View  Enquiry Details" },
    ],
 
    // Warehouse Customer Page Start
    "/warehouse-requests": [
      { label: "Dashboard", url: "/" },
      { label: "Warehouse Requests" },
    ],
 
    "/Create-warehouses-request": [
      { label: "Dashboard", url: "/" },
      { label: "Create Warehouses Request" },
    ],
 
    "/warehouse-request-responses/": [
      { label: "Dashboard", url: "/" },
      { label: "Warehouse Requests", url: "/warehouse-requests" },
      { label: "Warehouse Request Responses" },
    ],
 
    "/warehouse/create-warehouses": [
      {
        label: "Warehouse Request Responses",
        url: "/warehouse-request-responses/:id",
      },
      { label: "Create Requests" },
    ],
 
    "/warehouse-request-responses/:id": [
      { label: "Dashboard", url: "/" },
      { label: "List Of Warehouse Request", url: "/warehouse-requests" },
      { label: "Warehouse-request" },
    ],
 
    "/confirm-warehouse": [
      { label: "Dashboard", url: "/" },
      { label: "Warehouse Request", url: "/warehouse-requests" },
      {
        label: "Warehouse Request Responses",
        url: "/warehouse-request-responses/:id",
      },
      { label: "Confirm Warehouse" },
    ],
    // End Customer Warehouse
    // Warehouse Owner/Admin Page Start
    "/warehouse-requests-owner": [
      { label: "Dashboard", url: "/" },
      { label: "Warehouse Requests" },
    ],
    "/view-wh-request": [
      { label: "Dashboard", url: "/" },
      { label: "Warehouse Request", url: "/warehouse-requests-owner" },
      { label: "View Warehouse Request" },
    ],
 
    "/list-wh-admin": [
      { label: "Dashboard", url: "/" },
      { label: "List Of Warehouse" },
    ],
 
    "/my-warehouse": [
      { label: "Dashboard", url: "/" },
      { label: "My Warehouse" },
    ],
 
    "/create-warehouse": [
      { label: "Dashboard", url: "/" },
      { label: "My Warehouses", url: "/my-warehouses" },
      { label: "Create Warehouse" },
    ],
 
    "/edit-warehouse-request": [
      { label: "Dashboard", url: "/" },
      { label: "List Wh Admin", url: "/list-wh-admin" },
      { label: "Edit Warehouse Requests" },
    ],
 
    "/warehouse-add-requests": [
      { label: "Dashboard", url: "/" },
      { label: "Warehouse Add Requests" },
    ],
 
    "/view-warehouse-details/:id": [
      { label: "Dashboard", url: "/" },
      { label: "Warehouse Add Requests", url: "/warehouse-add-requests" },
      { label: "View Warehouse Details" },
    ],
    //  Warehouse Owner Page End
    "/user-documents": [
      { label: "Dashboard", url: "/" },
      { label: "Client Master", url: "/master-data/client-master" },
      { label: "User Documents" },
    ],
 
    "/warehouse-bookings": [
      { label: "Dashboard", url: "/" },
      { label: "Warehouse Bookings" },
    ],
 
    // CHA Admin //
    "/cha-services-requests": [
      { label: "Dashboard", url: "/" },
      { label: "Cha Services Requests" },
    ],
    "/cha-requests": [
      { label: "Dashboard", url: "/" },
      { label: "Cha Requests" },
    ],
    "/audit-details": [
      { label: "Dashboard", url: "/" },
      { label: "Cha Services Requests", url: "/cha-services-requests" },
      { label: "Audit Details" },
    ],
 
    "/my-profile": [{ label: "Dashboard", url: "/" }, { label: "My Profile" }],
 
    "/intelligence": [
      { label: "Dashboard", url: "/" },
      { label: "Intelligence" },
    ],
  };
 
  //  Step 1: Find the "closest matching path" from breadcrumbConfig
  const findClosestMatch = (pathname) => {
    const paths = Object.keys(breadcrumbConfig);
 
    // Sort rules:
    // 1. Admin routes first
    // 2. Longer routes first (more specific)
    const sortedPaths = paths.sort((a, b) => {
      const aIsAdmin = a.includes("/admin");
      const bIsAdmin = b.includes("/admin");
 
      if (aIsAdmin && !bIsAdmin) return -1;
      if (!aIsAdmin && bIsAdmin) return 1;
 
      // If both admin or both non-admin → sort by length (desc)
      return b.length - a.length;
    });
 
    // Now find match from sorted list - exact match first, then prefix match
    let matched = sortedPaths.find((route) => route === pathname);
    if (!matched) {
      matched = sortedPaths.find((route) => pathname.startsWith(route));
    }
 
    return breadcrumbConfig[matched];
  };
 
  //  Step 2: Use custom trail if found
  const customTrail = findClosestMatch(path);
 
  //  Step 3: Build auto breadcrumbs only if no custom match
  const pathnames = path
    .split("/")
    .filter((x) => x && !/^[a-f0-9]{24}$/i.test(x) && !/^\d+$/.test(x)); // skip IDs
 
  const autoTrail = pathnames.map((name, index) => ({
    label: name
      .replace(/-/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase()),
    url: `/${pathnames.slice(0, index + 1).join("/")}`,
  }));
 
  const breadcrumbs = customTrail || autoTrail;
 
  return (
    <nav aria-label="breadcrumb" className="mb-5">
      <ol
        className={`breadcrumb mb-0 d-flex align-items-center flex-wrap ${breadcrumbcls}`}
      >
        {breadcrumbs.map((item, index) => {
          const isLast = index === breadcrumbs.length - 1;
          return (
            <li
              key={item.label + index}
              className="breadcrumb-item d-flex align-items-center"
              aria-current={isLast ? "page" : undefined}
            >
              {isLast ? (
                <span>{item.label}</span>
              ) : (
                <>
                  <Link to={buildDynamicUrl(item.url)}>{item.label}</Link>
                  <ArrowForwardIosIcon sx={{ fontSize: 14, mx: 1 }} />
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
export default Breadcrumbs;
 